module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/amazon.6a6e4350.svg";